import React, { useContext, useEffect, Suspense, lazy } from 'react'
// import loadable from '@loadable/component'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { SetUserContext, UserContext, UserContextProvider } from './context api/UserContext'
import { DecodedToken } from './lib/DecodedTokenHelper'
import { ROUTES } from './shared/constants'
import { CategoryContextProvider } from './context api/Category/CategoryContext'
import { TmpOrderContextProvider } from './context api/TmpOrder/TmpOrderContext'
import {BeatPlanContextProvider} from './context api/BeatPlan/BeatPlanContext'
import { createBrowserHistory } from 'history'

import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import PrivateRoute from './lib/PrivateRoute'
import { SubCategoryContextProvider } from './context api/SubCategory/SubCategoryContext'
import { ProductContextProvider } from './context api/Product/ProductContext'
import { EmployeeContextProvider } from './context api/Employee/EmployeeContext'
import { BusinessConfiguration } from './pages/BusinessConfiguration'
import { BusinessZone } from './pages/BusinessZones'
import { BusinessStores } from './pages/BusinessStores'
import { ConfigurationContextProvider } from './context api/Configuration/ConfigurationContext'
import { FeatureContextProvider } from './context api/Features/FeatureContext'
import Product from './pages/Product/Product'
import EditCategory from './pages/Category/EditCatgeory'
import EditSubCategory from './pages/SubCategory/EditSubCategory'
import ViewSubCategory from './pages/ViewSubcategory'
import ViewCategory from './pages/ViewCategory'
import ViewProducts from './pages/ViewProducts'
import City from './pages/Masters/City'
import CityForm from './pages/Masters/CityForm'
import EditProduct from './pages/EditProduct'
import ViewLead from './pages/ViewLead'
import ViewBusiness from './pages/ViewBusiness'
import EditZone from './pages/Edit_Pages/EditZone'
import EditPosition from './pages/Edit_Pages/EditPosition'
import EditTotalLeave from './pages/Edit_Pages/EditTotalLeave'
import EditLeadType from './pages/Edit_Pages/EditLeadType'
import EditLeaveType from './pages/Edit_Pages/EditLeaveType'
import EditRegion from './pages/Edit_Pages/EditRegion'
import InvalidTokenHelper from './lib/InvalidTokenHelper'
import axios from 'axios'
import EditState from './pages/Edit_Pages/EditStates'
import DistrictForm from './pages/Masters/Districtform'
import SingleEmployeeAttendance from './pages/SingleEmployeeAttendance'
import AddProductCatalogue from './pages/AddProductCatalogue'
import ViewProductCatelouge from './pages/ViewProductCatelouge'
import EditProductCatalouge from './pages/EditProductCatalouge'
import Report from './pages/Reports/Report'
import TotalLeave from './pages/Masters/TotalLeave'
import TotalLeaveForm from './pages/Masters/TotalLeaveForm'
import AllLeaveRequests from './pages/AllLeaveRequests'
import AllAttendance from './pages/AllAttendance'
import AllEmployees from './pages/AllEmployees'
import AttendanceSumaryReport from './components/Reports/Attendance/AttendanceSumaryReport'
import AttendanceInTimeReport from './components/Reports/Attendance/AttendanceInTimeReport'
import MonthlyLateReport from './components/Reports/Attendance/MonthlyLateReport'
import CheckInCheckOutReport from './components/Reports/Attendance/CheckInCheckOutReport'
import LeaveReport from './components/Reports/Attendance/LeaveReport'
import ProductiveTimeReport from './components/Reports/Attendance/ProductiveTimeReport'
import LeadGenerationSummaryReport from './components/Reports/Lead/LeadGenerationSummaryReport'
import LeadStatusReport from './components/Reports/Lead/LeadStatusReport'
import LeadLikelyClosureReport from './components/Reports/Lead/LeadLikelyClosureReport'
import ProductCategoryLeadReport from './components/Reports/Lead/ProductCategoryLeadReport'
import ProductCategoryDetailedReportMTD from './components/Reports/Lead/ProductCategoryDetailedReportMTD'
import PromoterWiseReport from './components/Reports/Lead/PromoterWiseReport'
import TSMReport from './components/Reports/Lead/TSMReport'
import OutletWiseReport from './components/Reports/Lead/OutletWiseReport'
import LeadAgingReport from './components/Reports/Lead/LeadAgingReport'
import LeadDumpReportForPivot from './components/Reports/Lead/LeadDumpReportForPivot'
import TrainingReport from './components/Reports/Other/TrainingReport'
import RRReport from './components/Reports/Other/R&RReport'
import MerchandiseReport from './components/Reports/Other/MerchandiseReport'
import CustomerReport from './components/Reports/Other/CustomerReport'
import HygieneImprovementReport from './components/Reports/Other/HygieneImprovementReport'
import EditLead from './pages/Lead/EditLead'
import EditProductCatalogue from './pages/Edit_Pages/EditProductCatalogue'
import Customers from './pages/Customer/Customers'
import AddCustomer from './pages/Customer/AddCustomer'
import EditCustomer from './pages/Customer/EditCustomer'
import Taxes from './pages/Tax/Taxes'
import AddTax from './pages/Tax/AddTax'
import EditTax from './pages/Tax/EditTax'
import LeadSources from './pages/LeadSource/LeadSources'
import AddLeadSource from './pages/LeadSource/AddLeadSource'
import EditLeadSource from './pages/LeadSource/EditLeadSource'
import ViewPosition from './pages/ViewPosition'
import ViewLeadType from './pages/ViewLeadType'
import ViewTotalLeave from './pages/ViewTotalLeave'
import ViewLeadSource from './pages/ViewLeadSource'
import ViewTax from './pages/ViewTax'
import ViewLeaveType from './pages/ViewLeaveType'
import CustomerTypes from './pages/CustomerType/CustomerTypes'
import AddCustomerType from './pages/CustomerType/AddCustomerType'
import EditCustomerType from './pages/CustomerType/EditCustomerType'
import ViewCustomerType from './pages/ViewCustomerType'
import SalesChannelTypes from './pages/Sales_Channel_Type/SalesChannelTypes'
import AddSalesChannelType from './pages/Sales_Channel_Type/AddSalesChannelType'
import EditSalesChannelType from './pages/Sales_Channel_Type/EditSalesChannelType'
import PrimarySales from './pages/Sales/PrimarySales'
import EditDistrict from './pages/Edit_Pages/EditDistrict'
import EditCity from './pages/Edit_Pages/EditCity'
import EditArea from './pages/Edit_Pages/EditArea'
import EditStore from './pages/Edit_Pages/EditStore'
import ViewRegion from './pages/View_Pages/ViewRegion'
import ViewZone from './pages/View_Pages/ViewZone'
import ViewDistrict from './pages/View_Pages/ViewDistrict'
import ViewStore from './pages/View_Pages/ViewStore'
import ViewCity from './pages/View_Pages/ViewCity'
import ViewState from './pages/View_Pages/ViewState'
import ViewArea from './pages/View_Pages/ViewArea'
import LeadTypeConversions from './pages/LeadTypeConversion/LeadTypeConversions'
import AddLeadTypeConversion from './pages/LeadTypeConversion/AddLeadTypeConversion'
import EditLeadTypeConversion from './pages/LeadTypeConversion/EditLeadTypeConversion'
import ViewLeadTypeConversion from './pages/LeadTypeConversion/ViewLeadTypeConversion'
import Schemes from './pages/Scheme/Schemes'
import AddScheme from './pages/Scheme/AddScheme'
import EditScheme from './pages/Scheme/EditScheme'
import AddPrimarySales from './pages/Sales/AddPrimarySales'
import AddLead from './pages/Lead/AddLead'
import TSMDetailedReportMTD from './components/Reports/Lead/TSMDetailedReportMTD'
import Incentives from './pages/Incentive/Incentives'
import HolidaySetup from './pages/Masters/HolidaySetup'
import HolidayForm from './pages/Masters/HolidayForm'
import SalesReturn from './pages/Sales_Return/SalesReturn'
import AddLeadProducts from './pages/Lead/AddLeadProducts'
import SelectLeadProducts from './pages/Lead/SelectLeadProducts'
import AddOrder from './pages/Lead/AddOrder'
import ViewScheme from './pages/Scheme/ViewScheme'
import AchievementReport from './pages/Incentive/AchievementReport'
import EditLeaveRequest from './pages/Edit_Pages/EditLeaveRequest'
import ViewCustomer from './pages/Customer/ViewCustomer'
import EditPrimarySales from './pages/Sales/EditPrimarySales'
import ViewPrimarySales from './pages/Sales/ViewPrimarySales'
import ViewSalesReturn from './pages/Sales_Return/ViewSalesReturn'
import AddTarget from './pages/Target/AddTarget'
import QuaterlyEarningReport from './pages/Incentive/QuaterlyEarningReport'
import IncentiveReport from './pages/Incentive/IncentiveReport'
import QuaterlyVsActualAchievementReport from './pages/Incentive/QuaterlyVsActualAchievementReport'
import CreateNewPassword from './pages/CreateNewPassword'
import TeamLeaseDumpReport from './components/Reports/Attendance/TeamLeaseDumpReport'
import SalesDashboard from './pages/Sales/SalesDashboard'
import UploadStatus from './pages/UploadStatus/UploadStatus'
import CategoryStatus from './pages/UploadStatus/CategoryStatus'
import { OtherContextProvider } from './context api/Others/OtherContext'
import CategoryOverviewTable from './pages/UploadStatus/OverviewTable/CategoryOverviewTable'
import SubCategoryOverviewTable from './pages/UploadStatus/OverviewTable/SubCategoryOverviewTable'
import SubCategoryStatus from './pages/UploadStatus/SubCategoryStatus'
import ProductStatus from './pages/UploadStatus/ProductStatus'
import ProductOverviewTable from './pages/UploadStatus/OverviewTable/ProductOverviewTable'
import { toastMessage } from './shared/AlertPopup'
import AddTmpOrder from './pages/TmpOrder/AddTmpOrder'
import MyTmpOrders from './pages/TmpOrder/myTmpOrders'

import AddBeatPlan from './pages/Beat/AddBeatPlan'
import Beat from './pages/Beat/Beat'
import GeoLocation from './pages/Beat/geoLocation'

import { GenerateRoutes, routes, superAdminRoutes } from './utils/GenerateRouteHelper'
import { SuperAdminContextProvider } from './context api/SuperAdmin/SuperAdminContext'
import { CompanyConfigContextProvider } from './context api/Configuration/CompanyConfig'
const Sales = lazy(() => import('./pages/Sales'))
const Employee = lazy(() => import('./pages/Employee'))
const Products = lazy(() => import('./pages/Products'))

const AllProductCatalogue = lazy(() => import('./pages/AllProductCatalogue'))
const EditEmployee = lazy(() => import('./pages/EditEmployee'))
const Target = lazy(() => import('./pages/Target'))
const AllTargets = lazy(() => import('./pages/Target/AllTargets'))
const EditAttendance = lazy(() => import('./pages/EditAttendance'))
const EmployeeView = lazy(() => import('./pages/EmployeeView'))
const EditTarget = lazy(() => import('./pages/Target/EditTarget'))
const ProductsView = lazy(() => import('./pages/ProductsView'))
const TargetView = lazy(() => import('./pages/TargetView'))
const Masters = lazy(() => import('./pages/Masters/Masters'))
const Position = lazy(() => import('./pages/Masters/Position'))
const LeadType = lazy(() => import('./pages/Masters/LeadType'))
const LeaveType = lazy(() => import('./pages/Masters/LeaveType'))
const Region = lazy(() => import('./pages/Masters/Region'))
const Zone = lazy(() => import('./pages/Masters/zone'))
const State = lazy(() => import('./pages/Masters/State'))
const District = lazy(() => import('./pages/Masters/District'))
const Area = lazy(() => import('./pages/Masters/Area'))
const Store = lazy(() => import('./pages/Masters/Store'))
const TemplateCategory = lazy(() => import('./pages/Masters/TemplateCategory'))
const ChannelType = lazy(() => import('./pages/Masters/ChannelType'))
const PositionForm = lazy(() => import('./pages/Masters/PositionForm'))
const LeadTypeForm = lazy(() => import('./pages/Masters/LeadTypeForm'))
const LeaveTypeForm = lazy(() => import('./pages/Masters/LeaveTypeForm'))
const RegionForm = lazy(() => import('./pages/Masters/RegionForm'))
const ZoneForm = lazy(() => import('./pages/Masters/ZoneForm'))
const StateForm = lazy(() => import('./pages/Masters/StateForm'))
const AreaForm = lazy(() => import('./pages/Masters/AreaForm'))
const StoreForm = lazy(() => import('./pages/Masters/StoreForm'))
const TemplateCategoryForm = lazy(() => import('./pages/Masters/TemplateCategoryForm'))
const ChannelTypeForm = lazy(() => import('./pages/Masters/ChannelTypeForm'))

// const AllAttendance = lazy(() => import('./pages/AllAttendance'))
// const AllEmployees = lazy(() => import('./pages/AllEmployees'))
const AllLeads = lazy(() => import('./pages/AllLeads'))
// const AllLeaveRequests = lazy(() => import('./pages/AllLeaveRequests'))
const AllProducts = lazy(() => import('./pages/AllProducts'))
const Attendance = lazy(() => import('./pages/Attendance'))
const Home = lazy(() => import('./pages/Home'))
const Login = lazy(() => import('./pages/Login'))
const Signup = lazy(() => import('./pages/Signup'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const AllSubCategories = lazy(() => import('./pages/AllSubCategories'))
const AllCategories = lazy(() => import('./pages/AllCategories'))
const Setting = lazy(() => import('./pages/Setting'))
const Category = lazy(() => import('./pages/Category/Category'))
const SubCategory = lazy(() => import('./pages/SubCategory/SubCategory'))
const Loader = () => {
  return (
    <Backdrop open={true} style={{ zIndex: 1 }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}

export default function Routes() {
  const user = useContext(UserContext)
  const token = user && user.token
  console.log('TOKEN : ', token)
  const loggedInUser = useContext(SetUserContext)
  console.log(superAdminRoutes )
  const history = createBrowserHistory()
  // InvalidTokenHelper.setupInterceptors(history, user, loggedInUser)

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      //console.log('ERROR : ', error)
      const { status } = error.response
      console.log({ error: error.response })
      if (status === 401) {
        // localStorage.removeItem('user')
        // localStorage.removeItem('token')
        // localStorage.clear()
        // window.location.replace(ROUTES.HOME)
        return toastMessage('Token Is Expired', 'error')
      }
      return Promise.reject(error)
    }
  )
  return (
    <BrowserRouter history={history}>
      <Suspense fallback={<Loader />}>
        <Switch>
          <UserContextProvider>
            <CategoryContextProvider>
              <SubCategoryContextProvider>
                <ProductContextProvider>
                  <EmployeeContextProvider>
                    <ConfigurationContextProvider>
                      <FeatureContextProvider>
                        <OtherContextProvider>
                          <SuperAdminContextProvider>
                            <CompanyConfigContextProvider>
                              <Route exact path={ROUTES.SIGNUP}>
                                <Signup />
                              </Route>
                              <Route exact path={ROUTES.CREATE_NEW_PASSWORD}>
                                <CreateNewPassword />
                              </Route>
                              <Route exact path={ROUTES.HOME}>
                                <Login />
                              </Route>
                              <Route exact path={ROUTES.FORGOT_PASSWORD}>
                                <ForgotPassword />
                              </Route>

                              {routes.map((val) => (
                                <PrivateRoute exact path={ROUTES[val.route]}>
                                  <val.page />
                                </PrivateRoute>
                              ))}
                              {superAdminRoutes.map((val) => (
                                <PrivateRoute exact path={ROUTES[val.route]}>
                                  <val.page />
                                </PrivateRoute>
                              ))}
                              <PrivateRoute exact path={ROUTES.ATTENDANCE}>
                                <Attendance />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.CATEGORIES}>
                                <AllCategories />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.SETTING}>
                                <Setting />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.BUSINESS}>
                                <BusinessConfiguration />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.BUSINESS_ZONES}>
                                <BusinessZone />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.BUSINESS_STORES}>
                                <BusinessStores />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.PRODUCT_CATALOGUE}>
                                <AllProductCatalogue />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.HOLIDAY_SETUP}>
                                <HolidaySetup />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_HOLIDAY}>
                                <HolidayForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_HOLIDAY}>
                                <HolidayForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.SALES}>
                                <Sales />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.ATTENDANCE}>
                                <Attendance />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEADS}>
                                <AllLeads />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEAVE_REQUESTS}>
                                <AllLeaveRequests />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ALL_ATTENDANCE}>
                                <AllAttendance />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ALL_EMPLOYEES}>
                                <AllEmployees />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.DASHBOARD}>
                                <Home />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.PRODUCTS}>
                                <AllProducts />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.SUBCATEGORIES}>
                                <AllSubCategories />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_EMPLOYEE}>
                                <EditEmployee />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.SETTING}>
                                <Setting />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.SALESDASHBOARD}>
                                <SalesDashboard />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.SALES}>
                                <Sales />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EMPLOYEE}>
                                <Employee />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADDPRODUCTS}>
                                <Product />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.TARGET}>
                                <AddTarget />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ALL_TARGETS}>
                                <AllTargets />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_ATTENDANCE}>
                                <EditAttendance />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_EMPLOYEE}>
                                <EmployeeView />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_TARGET}>
                                <EditTarget />
                              </PrivateRoute>
                              {/* <PrivateRoute exact path={ROUTES.VIEW_PRODUCTS}>
                          <ProductsView />
                        </PrivateRoute> */}
                              <PrivateRoute exact path={ROUTES.VIEW_TARGET}>
                                <TargetView />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.MASTERS}>
                                <Masters />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.POSITION}>
                                <Position />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEAD_TYPE}>
                                <LeadType />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEAVE_TYPE}>
                                <LeaveType />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.REGION}>
                                <Region />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ZONE}>
                                <Zone />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.STATE}>
                                <State />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.DISTRICT}>
                                <District />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.AREA}>
                                <Area />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.STORE}>
                                <Store />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.TEMPLATE_CATEGORY}>
                                <TemplateCategory />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.CHANNEL_TYPE}>
                                <ChannelType />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.POSITION_FORM}>
                                <PositionForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEADTYPE_FORM}>
                                <LeadTypeForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEAVETYPE_FORM}>
                                <LeaveTypeForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.REGION_FORM}>
                                <RegionForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ZONE_FORM}>
                                <ZoneForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.STATE_FORM}>
                                <StateForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.DISTRICT_FORM}>
                                <DistrictForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.AREA_FORM}>
                                <AreaForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.STORE_FORM}>
                                <StoreForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.TEMPLATE_FORM}>
                                <TemplateCategoryForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.CHANNEL_FORM}>
                                <ChannelTypeForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_CATEGORY}>
                                <Category />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_SUBCATEGORY}>
                                <SubCategory />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_CATEGORY}>
                                <EditCategory />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_SUBCATEGORY}>
                                <EditSubCategory />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_SUBCATEGORY}>
                                <ViewSubCategory />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_CATEGORY}>
                                <ViewCategory />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_POSITION}>
                                <ViewPosition />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_LEADTYPE}>
                                <ViewLeadType />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_TOTALLEAVE}>
                                <ViewTotalLeave />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_LEADSOURCE}>
                                <ViewLeadSource />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_TAX}>
                                <ViewTax />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_LEAVETYPE}>
                                <ViewLeaveType />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_CUSTOMERTYPE}>
                                <ViewCustomerType />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_PRODUCTS}>
                                <ViewProducts />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.CITY}>
                                <City />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_PRODUCT}>
                                <EditProduct />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.CITY_FORM}>
                                <CityForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_LEAD}>
                                <ViewLead />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_BUSINESS}>
                                <ViewBusiness />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_REGION}>
                                <ViewRegion />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_DISTRICT}>
                                <ViewDistrict />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_ZONE}>
                                <ViewZone />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_STORE}>
                                <ViewStore />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_CITY}>
                                <ViewCity />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_STATE}>
                                <ViewState />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_AREA}>
                                <ViewArea />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_ZONE}>
                                <EditZone />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_POSITION}>
                                <EditPosition />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_LEADTYPE}>
                                <EditLeadType />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_LEAVETYPE}>
                                <EditLeaveType />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_TOTALLEAVE}>
                                <EditTotalLeave />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_REGION}>
                                <EditRegion />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_STATE}>
                                <EditState />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_DISTRICT}>
                                <EditDistrict />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_CITY}>
                                <EditCity />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_AREA}>
                                <EditArea />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_STORE}>
                                <EditStore />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_PRODUCT_CATALOUGE}>
                                <AddProductCatalogue />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_PRODUCT_CATALOUGE}>
                                <ViewProductCatelouge />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_PRODUCT_CATALOUGE}>
                                <EditProductCatalouge />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.REPORTS}>
                                <Report />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.TOTAL_LEAVE}>
                                <TotalLeave />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_TOTAL_LEAVE}>
                                <TotalLeaveForm />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_LEAVE_REQUEST}>
                                <EditLeaveRequest />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.ATTENDANCE_SUMMARY_REPORT}>
                                <AttendanceSumaryReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.IN_TIME_SUMMARY_REPORT}>
                                <AttendanceInTimeReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.CHECKIN_CHECKOUT_REPORT}>
                                <CheckInCheckOutReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.MONTHLY_LATE_REPORT}>
                                <MonthlyLateReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEAVE_REPORT}>
                                <LeaveReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.PRODUCTIVE_TIME_REPORT}>
                                <ProductiveTimeReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.TEAM_LEASE_DUMP_REPORT}>
                                <TeamLeaseDumpReport />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.LEAD_GENERATION_SUMMARY_REPORT}>
                                <LeadGenerationSummaryReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEAD_STATUS_REPORT}>
                                <LeadStatusReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEAD_LIKELY_CLOSURE_REPORT}>
                                <LeadLikelyClosureReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.PRODUCT_CATEGORY_LEAD_REPORT}>
                                <ProductCategoryLeadReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.PRODUCT_CATEGORY_DETAILED_REPORT_MTD}>
                                <ProductCategoryDetailedReportMTD />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.PROMOTER_WISE_REPORT}>
                                <PromoterWiseReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.TSM_REPORT}>
                                <TSMReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.OUTLET_WISE_REPORT}>
                                <OutletWiseReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEAD_AGING_REPORT}>
                                <LeadAgingReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEAD_DUMP_REPORT_FOR_PIVOT}>
                                <LeadDumpReportForPivot />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.TSM_DETAILED_REPORT_MTD}>
                                <TSMDetailedReportMTD />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.TRAINING_REPORT}>
                                <TrainingReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.R_R_REPORT}>
                                <RRReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.MERCHANDISE_REPORT}>
                                <MerchandiseReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.CUSTOMER_REPORT}>
                                <CustomerReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.HYGIENE_IMPROVEMENT_REPORT}>
                                <HygieneImprovementReport />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.ADD_LEAD}>
                                <AddLead />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_LEAD}>
                                <EditLead />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_CATALOG}>
                                <EditProductCatalogue />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_LEAD_PRODUCTS}>
                                <AddLeadProducts />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.SELECT_LEAD_PRODUCTS}>
                                <SelectLeadProducts />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_ORDER}>
                                <AddOrder />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.SINGLE_ATTENDANCE}>
                                <SingleEmployeeAttendance />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.CUSTOMERS}>
                                <Customers />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_CUSTOMER}>
                                <AddCustomer />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_CUSTOMER}>
                                <EditCustomer />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_CUSTOMER}>
                                <ViewCustomer />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.TAX}>
                                <Taxes />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_TAX}>
                                <AddTax />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_TAX}>
                                <EditTax />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.LEADSOURCE}>
                                <LeadSources />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_LEADSOURCE}>
                                <AddLeadSource />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_LEADSOURCE}>
                                <EditLeadSource />
                              </PrivateRoute>
                              {/*  */}
                              <PrivateRoute exact path={ROUTES.CUSTOMERTYPE}>
                                <CustomerTypes />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_CUSTOMERTYPE}>
                                <AddCustomerType />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_CUSTOMERTYPE}>
                                <EditCustomerType />
                              </PrivateRoute>
                              {/*  */}
                              {/*  */}
                              <PrivateRoute exact path={ROUTES.SALES_CHANNEL_TYPE}>
                                <SalesChannelTypes />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.ADD_SALES_CHANNEL_TYPE}>
                                <AddSalesChannelType />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_SALES_CHANNEL_TYPE}>
                                <EditSalesChannelType />
                              </PrivateRoute>
                              {/*  */}
                              <PrivateRoute exact path={ROUTES.LEADTYPE_CONVERSION}>
                                <LeadTypeConversions />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_LEADTYPE_CONVERSION}>
                                <AddLeadTypeConversion />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_LEADTYPE_CONVERSION}>
                                <EditLeadTypeConversion />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_LEADTYPE_CONVERSION}>
                                <ViewLeadTypeConversion />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.SCHEME}>
                                <Schemes />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ADD_SCHEME}>
                                <AddScheme />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_SCHEME}>
                                <EditScheme />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_SCHEME}>
                                <ViewScheme />
                              </PrivateRoute>
                              {/*  */}

                              <PrivateRoute exact path={ROUTES.PRIMARY_SALES}>
                                <PrimarySales />
                              </PrivateRoute>

                              <PrivateRoute exact path={ROUTES.ADD_PRIMARY_SALES}>
                                <AddPrimarySales />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.EDIT_PRIMARY_SALES}>
                                <EditPrimarySales />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_PRIMARY_SALES}>
                                <ViewPrimarySales />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.VIEW_SALES_RETURN}>
                                <ViewSalesReturn />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.INCENTIVE}>
                                <Incentives />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.SALES_RETURN}>
                                <SalesReturn />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.ACHIEVEMENT_REPORT}>
                                <AchievementReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.INCENTIVE_REPORT}>
                                <IncentiveReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.QUATERLY_EARNING_REPORT}>
                                <QuaterlyEarningReport />
                              </PrivateRoute>
                              <PrivateRoute exact path={ROUTES.QUATERLY_VS_ACTUAL_ACHIEVEMENT_REPORT}>
                                <QuaterlyVsActualAchievementReport />
                              </PrivateRoute>

                              {/* // temp order Routes */}

                              <TmpOrderContextProvider>
                                <PrivateRoute exact path={ROUTES.ADD_TMPORDER}>
                                  <AddTmpOrder />
                                </PrivateRoute>
                                <PrivateRoute exact path={ROUTES.VIEW_TMPORDER}>
                                  <AddTmpOrder />
                                </PrivateRoute>
                                <PrivateRoute exact path={ROUTES.MY_TMPORDERS}>
                                  <MyTmpOrders />
                                </PrivateRoute>
                              </TmpOrderContextProvider>
                              

                              <BeatPlanContextProvider>
                                <PrivateRoute exact path={ROUTES.ADD_BEAT_PLAN}>
                                  <AddBeatPlan />
                                </PrivateRoute>
                                <PrivateRoute exact path={ROUTES.EDIT_BEAT_PLAN}>
                                  <AddBeatPlan />
                                </PrivateRoute>
                                <PrivateRoute exact path={ROUTES.BEAT_PLANS}>
                                  <Beat />
                                </PrivateRoute>
                                <PrivateRoute exact path={ROUTES.GEOLOCATION}>
                                  <GeoLocation />
                                </PrivateRoute>
                              </BeatPlanContextProvider>

                              {/* <PrivateRoute exact path={ROUTES.EDIT_PRIMARY_SALES}>
                          <EditPrimarySales />
                        </PrivateRoute> */}
                            </CompanyConfigContextProvider>
                          </SuperAdminContextProvider>
                        </OtherContextProvider>
                      </FeatureContextProvider>
                    </ConfigurationContextProvider>
                  </EmployeeContextProvider>
                </ProductContextProvider>
              </SubCategoryContextProvider>
            </CategoryContextProvider>
          </UserContextProvider>
        </Switch>
      </Suspense>
    </BrowserRouter>
  )
}
